import { h } from 'preact';
import classnames from 'classnames';
import { IconFacebook, IconXSocial, IconInstagram } from '@popularlab/huey';

import { links } from '../../constants';

type Props = {
    className?: string;
};

export const Social = ({ className }: Props) => (
    <div className={classnames('c-social', className)}>
        <a
            aria-label="Hugo at Facebook"
            href={links.HUGO_FACEBOOK}
            rel="noreferrer noopener"
            target="_blank"
        >
            <IconFacebook title="Hugo at Facebook" size="32" />
        </a>
        <a aria-label="Hugo at X" href={links.HUGO_X} rel="noreferrer noopener" target="_blank">
            <IconXSocial title="Hugo at X" size="26" />
        </a>
        <a
            aria-label="Hugo at Instagram"
            href={links.HUGO_INSTAGRAM}
            rel="noreferrer noopener"
            target="_blank"
        >
            <IconInstagram title="Hugo at Instagram" size="32" />
        </a>
    </div>
);
